import { render, staticRenderFns } from "./NotifyGroupWizardCustom.vue?vue&type=template&id=7685b9c4&"
import script from "./NotifyGroupWizardCustom.vue?vue&type=script&lang=js&"
export * from "./NotifyGroupWizardCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports